import React from 'react';
import styles from './DynamicFormRenderer.module.css';

const NavigationButtons = ({ onBack, onNext, isLastSection, isSubmitting, isSubmitted }) => {
    return (
        <div className={styles.navigationBar}>
            <div className={styles.buttonGroup}>
                {onBack && (
                    <button onClick={onBack} className={styles.backButton} disabled={isSubmitting || isSubmitted}>
                        <svg className={styles.buttonIcon} viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                        </svg>
                        Back
                    </button>
                )}
                <button onClick={onNext} disabled={isSubmitting || isSubmitted} className={`${styles.nextButton} ${isLastSection ? styles.submitButton : ''}`}>
                    {isSubmitting ? (
                        <>
                            <svg className={styles.spinner} viewBox="0 0 24 24">
                                <circle className={styles.spinnerCircle} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            </svg>
                            Submitting...
                        </>
                    ) : (
                        <>
                            {isLastSection ? 'Submit Survey' : 'Next'}
                            <svg className={styles.buttonIcon} viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default NavigationButtons;